import { Service, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { User } from '../models/user.model';

export interface CreateUserRequest {
  name: string;
  surname: string;
  email: string;
  password: string;
  username: string;
  belt?: string;
}

export interface UpdateUserRequest {
  name?: string;
  username?: string;
  belt?: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

@Service()
export class UsersApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.api.baseUrl}/users`;

  registerUser(user: CreateUserRequest): Observable<{ guid: string }> {
    return this.http.post<{ guid: string }>(`${this.baseUrl}/register`, user);
  }

  getMe(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/me`);
  }

  updateMe(updates: UpdateUserRequest): Observable<User> {
    return this.http.put<User>(`${this.baseUrl}/me`, updates);
  }

  changeMyPassword(request: ChangePasswordRequest): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.baseUrl}/me/change-password`, request);
  }

  deleteMe(): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/me`);
  }
}
